module.exports = __webpack_public_path__ + "static/media/1200w.92f25345.jpg";